import React from 'react';
import { useRegieStore } from '@/zustand';

type RegieInitializerProps = {
  children: React.ReactNode;
};

const RegieInitializer = ({ children }: RegieInitializerProps) => {
  const hasRegies = useRegieStore((state) => state.hasRegies);
  const setHasRegies = useRegieStore((state) => state.setHasRegies);

  const [initialized, setInitialized] = React.useState(hasRegies !== null || null);

  const handleLoad = React.useCallback(() => {
    setHasRegies();
    setInitialized(true);
  }, [setHasRegies]);

  React.useEffect(() => {
    if (initialized === null) {
      handleLoad();
    }
  }, [handleLoad, initialized]);

  return children;
};

export default RegieInitializer;
